import booking from 'src/assets/booking.gif'
import airbnb from 'src/assets/airbnb.gif'
import expedia from 'src/assets/expedia.gif'
import figaro from 'src/assets/figaro_logo.gif'
import hrs from 'src/assets/hrs.gif'
import agoda from 'src/assets/agoda.gif'
import hotelbeds from 'src/assets/hotelbeds.gif'
import { PortalName } from 'src/api/api.generated'

export const getPortalIcon = (v: PortalName | string) => {
  switch (v) {
    case PortalName.BOOKING:
      return booking
    case PortalName.AIRBNB:
      return airbnb
    case PortalName.EXPEDIA:
      return expedia
    case PortalName.AGODA:
      return agoda
    case PortalName.HOTELBEDS:
      return hotelbeds
    case PortalName.HRS:
      return hrs
    default:
      return figaro
  }
}

export const getPortalName = (v: PortalName | string | null | undefined) => {
  switch (v) {
    case PortalName.BOOKING:
      return 'Booking.com'
    case PortalName.AIRBNB:
      return 'Airbnb'
    case PortalName.EXPEDIA:
      return 'Expedia'
    default:
      return 'By Figaro'
  }
}
